module.exports = __webpack_public_path__ + "swaziland.svg?2591a51f728d8033a0bb2fe9b85d6b41";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/swaziland.svg
// module id = 309
// module chunks = 10